import { createStore, applyMiddleware, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import * as reducers from './reducers';
import rootSaga from './sagas/root';
const initialState: any = {};
const sagaMiddleware = createSagaMiddleware();
const store: any = createStore(
    combineReducers(reducers), initialState,
    composeWithDevTools(applyMiddleware(sagaMiddleware)),
);

sagaMiddleware.run(rootSaga);

export default store;
